import { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { client } from "../../lib/config";
import { Printer } from "lucide-react";

export default function AdminQRCardPage() {
  const [settings, setSettings] = useState(null);
  const [link, setLink] = useState("");

  useEffect(() => {
    client.get("/settings").then((r) => {
      setSettings(r.data);
      setLink(r.data.gbp_review_link || "");
    }).catch(() => {});
  }, []);

  const missing = !link;

  return (
    <>
      <div className="mb-6 flex items-center justify-between flex-wrap gap-3 no-print">
        <div>
          <div className="wb-eyebrow">Marketing</div>
          <h1 className="wb-h2 mt-2">QR review card</h1>
          <p className="wb-body mt-2 max-w-2xl">
            Print this card on cardstock (letter or A6) and leave one at check-out. QR points to your
            Google Business Profile review link. Set the link in <a href="/admin/settings" className="text-[#B94A15] hover:underline">Settings → Google Business Profile review link</a>.
          </p>
        </div>
        <button onClick={() => window.print()} className="wb-btn-primary" data-testid="qr-print-btn" disabled={missing}>
          <Printer className="h-4 w-4" /> Print
        </button>
      </div>

      {missing ? (
        <div className="no-print wb-card bg-[#FCEEEA] border-[#E85D26] p-6 max-w-xl">
          <p className="text-[#1A1A1A] font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>
            GBP review link not set.
          </p>
          <p className="text-sm text-[#4A4641] mt-2">Add it in Settings before printing.</p>
        </div>
      ) : (
        <div className="flex justify-center">
          <div className="qr-card bg-[#FDFBF7] border-2 border-[#E85D26] p-10 w-[4.13in] h-[5.83in] flex flex-col items-center text-center" data-testid="qr-card">
            <img src="/images/logo-horizontal.png" alt="Westbridge Inn & Suites" className="h-16 w-auto" />
            <div className="mt-3 wb-eyebrow">Thanks for staying</div>
            <h2 className="text-2xl font-black text-[#1A1A1A] mt-3 leading-tight" style={{ fontFamily: "'Nunito', sans-serif" }}>
              How was your stay?
            </h2>
            <p className="text-sm text-[#4A4641] mt-2 max-w-[3.5in]">
              Your review helps other travelers find a clean bed and a warm welcome in Clinton, Missouri. Scan and share a word.
            </p>
            <div className="mt-6 p-3 bg-white border border-[#E5DFD3]">
              <QRCodeCanvas value={link} size={180} level="M" includeMargin={false} fgColor="#1A1A1A" bgColor="#FDFBF7" data-testid="qr-canvas" />
            </div>
            <p className="text-xs text-[#4A4641] mt-4 break-all">{link}</p>
            <p className="text-xs text-[#B94A15] font-bold mt-3" style={{ fontFamily: "'Nunito', sans-serif" }}>
              Great service. Clean rooms.
            </p>
            <p className="text-xs text-[#4A4641] mt-1">{settings?.phone} · {settings?.address_line1}, {settings?.address_locality} {settings?.address_region}</p>
          </div>
        </div>
      )}

      <style>{`
        @media print {
          @page { size: letter; margin: 0.5in; }
          .no-print, aside, nav[aria-label="Admin"] { display: none !important; }
          main { margin-left: 0 !important; padding: 0 !important; }
          body { background: white !important; }
          .qr-card { border-color: #E85D26 !important; box-shadow: none; }
        }
      `}</style>
    </>
  );
}
